import { z } from 'zod';

/** As flags do feature-flag-service (`currentFeatures(system: USER_APP)`) que a
 *  corrida com a 99 lê — as mesmas chaves que o app Flutter consulta
 *  (`packages/mobility/common/lib/src/shared/feature_flags.dart`). O customer-api
 *  repassa só estas; o resto da lista do legado não sai de lá. */
export const MOBILITY_99_FEATURE_FLAGS = ['mobility_99', 'mobility_99_help_center'] as const;

export interface Mobility99AccessInput {
  /** `policyAccess` contém `mobility`; `null` = não resolvido. */
  mobilityPolicy: boolean | null;
  /** `policyGetAccessModal.smartMobility`; `null` = não resolvido. */
  smartMobility: boolean | null;
  /** `currentFeatures(USER_APP)` filtradas; `null` = não resolvido. */
  featureFlags: readonly string[] | null;
}

export const Mobility99EntrySchema = z
  .object({ offer: z.boolean(), helpCenter: z.boolean() })
  .strict();
export type Mobility99Entry = z.infer<typeof Mobility99EntrySchema>;

const HIDDEN: Mobility99Entry = { offer: false, helpCenter: false };

/**
 * Se a corrida com a 99 aparece: a barra "CORRIDAS" da home nova do app
 * (`get_mobility_99_home_banner_state.dart`), sem o Smart Mobility (spec §4).
 * Dado não resolvido esconde, como o `Hidden` do legado em exceção. Sem a
 * política `mobility`, sem `smartMobility` ("um checkbox governa a barra",
 * commit `6769d7369` do app) ou sem a flag `mobility_99`, esconde. Gastos
 * bloqueados NÃO entram, como no legado. Canal (app nativo) e a capacidade
 * da ponte ficam no cliente.
 */
export function mobility99Entry(input: Mobility99AccessInput): Mobility99Entry {
  const { mobilityPolicy, smartMobility, featureFlags } = input;
  if (mobilityPolicy === null || smartMobility === null || featureFlags === null) return HIDDEN;
  if (!mobilityPolicy || !smartMobility || !featureFlags.includes('mobility_99')) return HIDDEN;
  return { offer: true, helpCenter: featureFlags.includes('mobility_99_help_center') };
}
